/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2026 (c) Miriam Mack, ISW University of Stuttgart (for umati and VDW e.V.)
 */

// Must match the password policy configured in the backend (ASP.NET Identity).
export const MIN_PASSWORD_LENGTH = 5;

export const passwordError = (password: string): string | null => {
  if (!password) return 'Please enter a password.';
  if (password.length < MIN_PASSWORD_LENGTH) return `The password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  return null;
};
